import{gql as c}from"@grandvisionhq/graphql";const t=c`
  mutation AddProductBackInStockSubscription($input: AddProductBackInStockSubscriptionInput!) {
    addProductBackInStockSubscription(input: $input) {
      ...AddProductBackInStockSubscriptionSuccessFragment
      ...AddProductBackInStockSubscriptionFailureFragment
    }
  }
  ${c`
  fragment AddProductBackInStockSubscriptionSuccessFragment on AddProductBackInStockSubscriptionSuccessResponse {
    result {
      success
    }
  }
`}
  ${c`
  fragment AddProductBackInStockSubscriptionFailureFragment on AddProductBackInStockSubscriptionFailureResponse {
    failures {
      ... on BackInStockAlreadySubscribedFailure {
        message
      }
    }
  }
`}
`;export{t as ADD_PRODUCT_BACK_IN_STOCK_SUBSCRIPTION};
//# sourceMappingURL=add-product-back-in-stock-subscription.js.map
